<form
  #formRef="ngForm"
  [formGroup]="form!"
>
  @for (field of filteredConfig(); track field.name) {
    <ng-container
      libdFormField
      [config]="field"
    />
  }
</form>
